/**
 * Meta Ads Configuration Types
 * Tipos para configuração da API do Meta Ads
 */

export type DatePreset =
  | 'today'
  | 'yesterday'
  | 'last_7d'
  | 'last_14d'
  | 'last_30d'
  | 'this_month'
  | 'last_month';

export type InsightsLevel = 'account' | 'campaign' | 'adset' | 'ad';

export type TimeIncrement = '1' | 'daily' | 'monthly';

export type TokenStatus = 'valido' | 'expirando_em_breve' | 'expirado';

export interface MetaAdsConfig {
  id: string;
  perfil_meta: string;
  url_contas: string;
  token: string;
  token_data_validade: string;
  date_preset: DatePreset;
  api_version: string;
  insights_level: InsightsLevel;
  insights_limit: string;
  time_increment: TimeIncrement;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  updated_by: string | null;
}

export interface MetaAdsConfigInput {
  perfil_meta: string;
  url_contas: string;
  token: string;
  token_data_validade: Date;
  date_preset: DatePreset;
  api_version: string;
  insights_level: InsightsLevel;
  insights_limit: string;
  time_increment: TimeIncrement;
}

// Helper functions
export function maskToken(token: string): string {
  if (token.length <= 4) return token;
  return '•'.repeat(token.length - 4) + token.slice(-4);
}

export function getTokenStatus(expirationDate: string): TokenStatus {
  const now = new Date();
  const expiration = new Date(expirationDate);
  const daysUntilExpiration = Math.ceil((expiration.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (daysUntilExpiration < 0) return 'expirado';
  if (daysUntilExpiration <= 7) return 'expirando_em_breve';
  return 'valido';
}

export function getDaysUntilExpiration(expirationDate: string): number {
  const now = new Date();
  const expiration = new Date(expirationDate);
  return Math.ceil((expiration.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
}

// Options for selects
export const DATE_PRESET_OPTIONS = [
  { value: 'today', label: 'Hoje' },
  { value: 'yesterday', label: 'Ontem' },
  { value: 'last_7d', label: 'Últimos 7 dias' },
  { value: 'last_14d', label: 'Últimos 14 dias' },
  { value: 'last_30d', label: 'Últimos 30 dias' },
  { value: 'this_month', label: 'Este mês' },
  { value: 'last_month', label: 'Mês passado' },
] as const;

export const INSIGHTS_LEVEL_OPTIONS = [
  { value: 'account', label: 'Conta' },
  { value: 'campaign', label: 'Campanha' },
  { value: 'adset', label: 'Conjunto de Anúncios' },
  { value: 'ad', label: 'Anúncio' },
] as const;

export const TIME_INCREMENT_OPTIONS = [
  { value: '1', label: 'Horário' },
  { value: 'daily', label: 'Diário' },
  { value: 'monthly', label: 'Mensal' },
] as const;
